import React from 'react';
import {
  Callout as BPCallout,
  CalloutProps as ICalloutProps,
  Intent
} from '@blueprintjs/core';

/**
 * Based on Blueprint's Callout object
 * https://blueprintjs.com/docs/#core/components/callout
 *
 * TODO: Find all Callout[intent=danger]; replace with <Error /> component that
 * adds tabIndex="0" and is WCAG compliant
 *
 */
const Callout: React.FC<ICalloutProps> = (props) => {
  if (props.intent === Intent.DANGER) {
    console.warn(
      'Callout: It looks like you are using this for an Error with intent="danger".\nInstead, use <ErrorCallout />. And make sure to place <ErrorCallout /> above related form for WCAG purposes.'
    );
  }
  return <BPCallout {...props} />;
};

export default Callout;
